import "lazysizes";
import "bootstrap";
import "@lib/browser-compatibility"; // Side effect import
import { cart } from "@lib/cart";
import { spot } from "@lib/spot";
import jquery from "jquery";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.jQuery = jquery;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.$ = jquery;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.cart = cart;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.spot = spot;
